export default __webpack_public_path__ + "static/media/lifeSituation.385693e4.svg";